var map = {
	"./audio.svg": "302c",
	"./cloud.svg": "7012",
	"./ctgpt.svg": "3b23",
	"./finac.svg": "022e",
	"./geogr.svg": "55b7",
	"./image.svg": "84fe",
	"./langs.svg": "53fc",
	"./music.svg": "a7e4",
	"./scity.svg": "0116",
	"./stand.svg": "e4b8",
	"./swdev.svg": "104c",
	"./web30.svg": "a374"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1c9a";